import { Component, input } from '@angular/core';
import { AdvertViewModel } from '@models/advert/advert';
import { TranslateModule } from '@ngx-translate/core';
import { NumeralPipe } from '../../../../pipes/numeral.pipe';
import { ConvertDatePipe } from '@pipes/convert-date.pipe';

@Component({
    selector: 'parking-space-stats',
    templateUrl: './parking-space-stats.component.html',
    imports: [TranslateModule, NumeralPipe, ConvertDatePipe]
})
export class ParkingSpaceStatsComponent {
    readonly advert = input<AdvertViewModel>(undefined);
}
